<dsy-pagination
  [enableSizer]="showSizerSignal()"
  [entriesSizer]="entriesSizerSignal()"
  [labelSizer]="'PD.LABELS.SHOWING' | translate"
  [totalElementsLabel]="totalElementsLabelSignal()"
  [paginationElements]="paginationElementsSignal()"
  [selectedIndex]="store.pageIndex()"
  [renderChevronsAsButtons]="false"
  [renderPagesAsButtons]="false"
>
</dsy-pagination>
